import type * as React from 'react'
import { GiveawayTheme, Maybe } from '@/types/codegen-contentful'

declare module 'react' {
  interface CSSProperties {
    [varName: `--${string}`]: string | number | undefined
  }
}

const defaultColors: React.CSSProperties = {
  '--giveaway-background-primary-dark': '#00142e',
  '--giveaway-background-primary-light': '#ffffff',
  '--giveaway-background-subtle-light': '#e6e8ea',
  '--giveaway-background-subtlest-light': '#f8fbff',
  '--giveaway-primary-accent-dark': '#313131',
  '--giveaway-primary-accent': '#4a4a4a',
  '--giveaway-primary-dark': '#2c2c2c',
  '--giveaway-primary-subtle-light': '#ffb19c',
  '--giveaway-primary-subtle': '#eabf07',
  '--giveaway-primary': '#333333',
  '--giveaway-secondary-accent': '#304a6e',
  '--giveaway-secondary': '#cc0069',
  '--giveaway-subtle': '#535f66',
  '--giveaway-text-primary-dark': '#000000',
  '--giveaway-text-primary-light': '#ffffff',
  '--giveaway-text-subtle-light': '#4e4e4e',
}

export const getCustomColors = (theme?: Maybe<GiveawayTheme>): React.CSSProperties => {
  if (!theme) return defaultColors

  return {
    ...defaultColors,
    '--giveaway-background-primary-dark':
      theme.backgroundPrimaryDark ?? defaultColors['--giveaway-background-primary-dark'],
    '--giveaway-background-primary-light':
      theme.backgroundPrimaryLight ?? defaultColors['--giveaway-background-primary-light'],
    '--giveaway-background-subtle-light':
      theme.backgroundSubtleLight ?? defaultColors['--giveaway-background-subtle-light'],
    '--giveaway-background-subtlest-light':
      theme.backgroundSubtlestLight ?? defaultColors['--giveaway-background-subtlest-light'],
    '--giveaway-primary-accent-dark': theme.primaryAccentDark ?? defaultColors['--giveaway-primary-accent-dark'],
    '--giveaway-primary-accent': theme.primaryAccent ?? defaultColors['--giveaway-primary-accent'],
    '--giveaway-primary-dark': theme.primaryDark ?? defaultColors['--giveaway-primary-dark'],
    '--giveaway-primary-subtle-light': theme.primarySubtleLight ?? defaultColors['--giveaway-primary-subtle-light'],
    '--giveaway-primary-subtle': theme.primarySubtle ?? defaultColors['--giveaway-primary-subtle'],
    '--giveaway-primary': theme.primary ?? defaultColors['--giveaway-primary'],
    '--giveaway-secondary-accent': theme.secondaryAccent ?? defaultColors['--giveaway-secondary-accent'],
    '--giveaway-secondary': theme.secondary ?? defaultColors['--giveaway-secondary'],
    '--giveaway-subtle': theme.subtle ?? defaultColors['--giveaway-subtle'],
    '--giveaway-text-primary-dark': theme.textPrimaryDark ?? defaultColors['--giveaway-text-primary-dark'],
    '--giveaway-text-primary-light': theme.textPrimaryLight ?? defaultColors['--giveaway-text-primary-light'],
    '--giveaway-text-subtle-light': theme.textSubtleLight ?? defaultColors['--giveaway-text-subtle-light'],
  }
}
